import { CodeHighlightNode, CodeNode } from "@lexical/code"
import { LinkNode } from "@lexical/link"
import { ListItemNode, ListNode } from "@lexical/list"
import { CHECK_LIST, TRANSFORMERS } from "@lexical/markdown"
import { HeadingNode, QuoteNode } from "@lexical/rich-text"
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table"
import { TextNode } from "lexical"

import { InlineImageNode } from "@/components/lexical/nodes/inline-image/node"
import { RawHtmlNode } from "@/components/lexical/nodes/raw-html/node"

import { CitationNode } from "./nodes/citation"
import { ExtendedTextNode } from "./nodes/extended-text/node"
import { ExternalMCPMentionNode } from "./nodes/external-mcp-mention/node"
import { MathNode } from "./nodes/math"
import { MentionNode } from "./nodes/mention/node"
import { ObjectLinkNode } from "./nodes/object-link"
import { PlaceholderNode } from "./nodes/placeholder/node"
import { QuestionNode } from "./nodes/question/node"
import { QuestionTransformer, RawHtmlTransformer, TableTransformer } from "./transformers"
import { CitationTransformer } from "./transformers/citation"
import { MathBlockTransformer, MathInlineTransformer } from "./transformers/math"
import { ObjectLinkTransformer } from "./transformers/object-link"

export const LEXICAL_NODES = [
  ExtendedTextNode,
  {
    replace: TextNode,
    with: (node: TextNode) => new ExtendedTextNode(node.__text),
    withKlass: ExtendedTextNode,
  },
  HeadingNode,
  QuoteNode,
  ListNode,
  ListItemNode,
  CodeNode,
  CodeHighlightNode,
  LinkNode,
  TableNode,
  TableRowNode,
  TableCellNode,
  InlineImageNode,
  RawHtmlNode,
  MentionNode,
  ExternalMCPMentionNode,
  PlaceholderNode,
  QuestionNode,
  CitationNode,
  MathNode,
  ObjectLinkNode,
]

export const MARKDOWN_TRANSFORMERS = [
  CHECK_LIST,
  ...TRANSFORMERS,
  TableTransformer,
  QuestionTransformer,
  RawHtmlTransformer,
  CitationTransformer,
  MathBlockTransformer,
  MathInlineTransformer,
  ObjectLinkTransformer,
]
